// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICustomPageable } from './ICustomPageable';
import {
    ICustomPageableFromJSON,
    ICustomPageableFromJSONTyped,
    ICustomPageableToJSON,
    ICustomPageableToJSONTyped,
} from './ICustomPageable';
import type { IPublicStatementInfoDto } from './IPublicStatementInfoDto';
import {
    IPublicStatementInfoDtoFromJSON,
    IPublicStatementInfoDtoFromJSONTyped,
    IPublicStatementInfoDtoToJSON,
    IPublicStatementInfoDtoToJSONTyped,
} from './IPublicStatementInfoDto';

/**
 * 
 * @export
 * @interface ICustomPagePublicStatementInfoDto
 */
export interface ICustomPagePublicStatementInfoDto {
    /**
     * 
     * @type {number}
     * @memberof ICustomPagePublicStatementInfoDto
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPagePublicStatementInfoDto
     */
    size?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPagePublicStatementInfoDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPagePublicStatementInfoDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPagePublicStatementInfoDto
     */
    empty?: boolean;
    /**
     * 
     * @type {Array<IPublicStatementInfoDto>}
     * @memberof ICustomPagePublicStatementInfoDto
     */
    content?: Array<IPublicStatementInfoDto>;
    /**
     * 
     * @type {ICustomPageable}
     * @memberof ICustomPagePublicStatementInfoDto
     */
    pageable?: ICustomPageable;
    /**
     * 
     * @type {number}
     * @memberof ICustomPagePublicStatementInfoDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPagePublicStatementInfoDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPagePublicStatementInfoDto
     */
    total_elements?: number;
}

/**
 * Check if a given object implements the ICustomPagePublicStatementInfoDto interface.
 */
export function instanceOfICustomPagePublicStatementInfoDto(value: object): value is ICustomPagePublicStatementInfoDto {
    return true;
}

export function ICustomPagePublicStatementInfoDtoFromJSON(json: any): ICustomPagePublicStatementInfoDto {
    return ICustomPagePublicStatementInfoDtoFromJSONTyped(json, false);
}

export function ICustomPagePublicStatementInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICustomPagePublicStatementInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'] == null ? undefined : json['number'],
        'size': json['size'] == null ? undefined : json['size'],
        'last': json['last'] == null ? undefined : json['last'],
        'first': json['first'] == null ? undefined : json['first'],
        'empty': json['empty'] == null ? undefined : json['empty'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IPublicStatementInfoDtoFromJSON)),
        'pageable': json['pageable'] == null ? undefined : ICustomPageableFromJSON(json['pageable']),
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
    };
}

export function ICustomPagePublicStatementInfoDtoToJSON(json: any): ICustomPagePublicStatementInfoDto {
    return ICustomPagePublicStatementInfoDtoToJSONTyped(json, false);
}

export function ICustomPagePublicStatementInfoDtoToJSONTyped(value?: ICustomPagePublicStatementInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'last': value['last'],
        'first': value['first'],
        'empty': value['empty'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IPublicStatementInfoDtoToJSON)),
        'pageable': ICustomPageableToJSON(value['pageable']),
        'totalPages': value['total_pages'],
        'numberOfElements': value['number_of_elements'],
        'totalElements': value['total_elements'],
    };
}

